import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d132e7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-layout__content-wrapper" }
const _hoisted_2 = { class: "main-layout__data-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-layout__divider" }, "|", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-layout__divider" }, "|", -1))
const _hoisted_5 = {
  key: 0,
  class: "main-layout__divider"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_MoneyInfo = _resolveComponent("MoneyInfo")!
  const _component_LogOut = _resolveComponent("LogOut")!
  const _component_LanguageSwitcher = _resolveComponent("LanguageSwitcher")!

  return (_ctx.user?.data?.isApproved)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["main-layout__bg", { [_ctx.className]: !!_ctx.className }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_UserInfo, {
              image: _ctx.image,
              email: _ctx.affiliate.credentials?.email,
              id: _ctx.affiliate.id,
              className: "main-layout__wrapper"
            }, null, 8, ["image", "email", "id"]),
            _hoisted_3,
            _createVNode(_component_MoneyInfo, {
              approve: _ctx.approve,
              hold: _ctx.hold,
              profit: _ctx.profit,
              isMediaBuying: _ctx.user.data?.isMediaBuying,
              className: "main-layout__wrapper"
            }, null, 8, ["approve", "hold", "profit", "isMediaBuying"])
          ]),
          _hoisted_4,
          _createVNode(_component_LogOut, { onLogOut: _ctx.logout }, null, 8, ["onLogOut"]),
          (_ctx.$q.screen.width >= 1280)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "|"))
            : _createCommentVNode("", true),
          (_ctx.$q.screen.width >= 1280)
            ? (_openBlock(), _createBlock(_component_LanguageSwitcher, { key: 1 }))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}